'use client';

import React from 'react';
import styled from '@benzinga/themetron';
import { sanitizeHTML } from '@benzinga/frontend-utils';
import classNames from 'classnames';

export interface StatBoxProps {
  className?: string;
  context?: string;
  title: string;
  value: string;
  valueElement?: React.ReactNode;
}

export const StatBox: React.FC<StatBoxProps> = ({ className, context, title, value, valueElement }) => {
  return (
    <StatBoxContainer>
      <div
        className={classNames(
          `stat-box border-2 border-gray-200 flex items-center justify-center px-4 py-2 rounded text-center`,
          { [`${className}`]: !!className },
        )}
      >
        <div>
          <h4 className="title font-bold truncate-2-lines" dangerouslySetInnerHTML={{ __html: sanitizeHTML(title) }} />
          {valueElement ? (
            valueElement
          ) : (
            <div
              className="value text-lg font-bold truncate-2-lines"
              dangerouslySetInnerHTML={{ __html: sanitizeHTML(value) }}
            />
          )}
          {context && (
            <div
              className="context text-xs font-bold truncate-2-lines"
              dangerouslySetInnerHTML={{ __html: sanitizeHTML(context) }}
            />
          )}
        </div>
      </div>
    </StatBoxContainer>
  );
};

const StatBoxContainer = styled.div`
  .title {
    font-size: 0.8rem;
  }
  @media (max-width: 800px) {
    .stat-box {
      padding: 0.25rem 0.5rem;
    }
    /* .value {
      font-size: 0.6rem;
    } */
  }
`;

export const StatBoxesContainer = styled.div`
  width: 100%;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin-bottom: 0.5rem;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  @media (max-width: 800px) {
    grid-template-columns: repeat(2, 1fr);
    grid-auto-rows: 1fr;
  }
`;
